/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';
import CardProduto from '../../../../components/CardProd';

/*Import Requisição API*/
import api from '../../../../api';
import { useAuth } from '../../../../context/AuthContext';
import { useFavorites } from '../../../../context/FavoritesContext';

export default function Favoritos() {
  const { userId } = useAuth();
  const { favorites } = useFavorites();
  const [produtosFav, setProdutosFav] = useState([]);
  const [texto, setTexto] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const caixaDeDialogo = useRef(null);

  useEffect(() => {
    caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
  }, []);

  const fecharModal = () => {
    if (caixaDeDialogo.current) {
      caixaDeDialogo.current.close();
    }
  };

  const mostrarModal = () => {
    if (caixaDeDialogo.current) {
      caixaDeDialogo.current.showModal();
    }
  };

  const compartilharFavoritos = async () => {
    try {
      const response = await api.post('/favoritos/compartilhar', {}, { withCredentials: true });
      if (!response.data?.success || !response.data?.token) {
        throw new Error('Token nao retornado');
      }

      const link = `${window.location.origin}/favoritos/publico/${response.data.token}`;
      await navigator.clipboard.writeText(link);
      setTexto('Link dos favoritos copiado para a area de transferencia.');
      setModalAberto(true);
      mostrarModal();
    } catch (error) {
      console.error('Erro ao compartilhar favoritos:', error);
      setTexto('Nao foi possivel gerar link de compartilhamento.');
      setModalAberto(true);
      mostrarModal();
    }
  };

  useEffect(() => {
    if (!userId) return;

    const fetchFavoritos = async () => {
      try {
        console.log('➡️ Buscando favoritos do usuário', userId);
        const res = await api.get(`/favoritos/${userId}`, { withCredentials: true });

        if (res.data.success) {
          const prods = res.data.data.map(fav => ({
            id_variacao: fav.id_variacao,
            id: fav.id_produto,
            nome: fav.nome_produto,
            preco: fav.preco,
            estoque: fav.estoque,
            cor: fav.cor,
            tamanho: fav.tamanho,
            material: fav.material,
            tipo: fav.tipo,
            unidades_por_pacote: fav.unidades_por_pacote,
            imagem_principal: fav.imagem_principal
          }));

          setProdutosFav(prods);
        }
      } catch (err) {
        console.error('Erro ao buscar favoritos:', err);
        setTexto('Erro ao carregar seus favoritos. Tente novamente.');
        setModalAberto(true);
      }
    };

    fetchFavoritos();
  }, [userId, favorites]);

  return (
    <section className='container-principal-favoritos'>
      <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
        <div className='conteudo-dialog'>
          <div className="dialog-texto">
            <p>{texto}</p>
            <button id="botao" onClick={fecharModal}>
              Ok
            </button>
          </div>
        </div>
      </dialog>

      <Cabecalho />
      <CookieAceite />

      <main>
        <MenuLateral />

        <section className='conteudo-favoritos'>
          <div className='titulo-perfil'>
            <h1><span>Perfil</span> &gt; Favoritos</h1>
          </div>

          <BtnVoltar />
          <div className='container-favoritos'>
            <div className='lista-favoritos'>
              {produtosFav.length > 0 ? (
                produtosFav.map(prod => (
                  <CardProduto key={prod.id_variacao} prod={prod} />
                ))
              ) : (
                <p>Você ainda não tem produtos favoritos.</p>
              )}
            </div>
          </div>
          <button type='button' className='btn-compartilhar-favoritos' onClick={compartilharFavoritos}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.833 5.00016L12.4997 3.3335C13.333 2.50016 14.9997 2.50016 15.833 3.3335L16.6663 4.16683C17.4997 5.00016 17.4997 6.66683 16.6663 7.50016L12.4997 11.6668C11.6663 12.5002 9.99967 12.5002 9.16634 11.6668M9.16634 15.0002L7.49967 16.6668C6.66634 17.5002 4.99967 17.5002 4.16634 16.6668L3.33301 15.8335C2.49967 15.0002 2.49967 13.3335 3.33301 12.5002L7.49967 8.3335C8.33301 7.50016 9.99967 7.50016 10.833 8.3335" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Compartilhar favoritos
          </button>
        </section>
      </main>

      <Rodape />
    </section>
  );
}